import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import type {
    GetContactAudienceMemberships as GetContactAudienceMembershipsQuery,
    GetContactAudienceMembershipsVariables as GetContactAudienceMembershipsQueryVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT_AUDIENCES_MEMBERSHIPS from '../peep/email-marketing/audiences/graphql/queries/get-contact-audience-memberships.graphql';

import {PeepEmRating} from './peep-em-rating';
import {PeepSendTo} from './peep-send-to';

type Props = {
    peepId: string;
};

export function PeepAvatarFooterWrapper(props: Props) {
    const {data} = useQuery<
        GetContactAudienceMembershipsQuery,
        GetContactAudienceMembershipsQueryVariables
    >(GET_CONTACT_AUDIENCES_MEMBERSHIPS, {
        variables: {personId: props.peepId},
    });

    return (
        <div>
            <PeepEmRating
                {...props}
                hasUnsubscribedFromAllAudiences={
                    data && data.contact && data.contact.hasUnsubscribedFromAllAudiences
                        ? data.contact.hasUnsubscribedFromAllAudiences
                        : undefined
                }
            />
            <PeepSendTo {...props} />
        </div>
    );
}
